import Debug from 'debug'
import { InteractionStateStoreModule } from '../../../store'
import { InteractionStateMachineData } from '../interaction-state-machine-data'

const debug = Debug('interaction-initial-state');

export class InitialState<TState> {

  public readonly name = 'initial-state'

  stateEvents: {
    onWaitingForRemoteState: () => void,
    onLoaded: () => void,
    onResetComponent: (state: TState | null) => void
  }

  constructor(private stateStore: InteractionStateStoreModule,
              private data: InteractionStateMachineData) {
  }

  start() {

    debug('start', this.data.id, this.data.type)

    switch (this.stateStore.remoteStatePhase) {
      case 'none':
      case 'loading':
      case 'error':
        this.stateEvents.onWaitingForRemoteState()
        break
      case 'loaded':
        this.initializeComponent()
        break
    }
  }

  private initializeComponent() {

    debug('initialize-component', this.data.id, this.data.type)

    let state: TState | null = null

    const findResult = this.stateStore.findState<TState>(this.data.id)
    if (findResult.success) {
      debug('found state', this.data.id, findResult.value.type, findResult.value.state)
      if (findResult.value.type === this.data.type) {
        state = findResult.value.state
      } else {
        debug(`type mismatch between stored state's type (${findResult.value.type}) and object's type (${this.data.type}), skipping state use`);
      }
    }
    
    this.stateEvents.onResetComponent(state)
    this.stateEvents.onLoaded()
  }
}
